import React, { createContext, useContext, useState, useEffect } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [clients, setClients] = useState(() => {
    const storedClients = localStorage.getItem('clients');
    return storedClients ? JSON.parse(storedClients) : [];
  });

  useEffect(() => {
    if (clients && clients.length > 0) {
      localStorage.setItem('clients', JSON.stringify(clients));
    } else {
      localStorage.removeItem('clients');
    }
  }, [clients]);

  return (
    <AppContext.Provider value={{ clients, setClients }}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
